/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useMutation } from "redux-query-react";
import ReactECharts from "echarts-for-react";
import { apiMutation } from "../query-configs/widget.js";
import { groupData } from "../jsonStatHelper";

const controller = new AbortController();

const GraphMultiSeries = ({ module, setTableId }) => {
  const { queries } = module;
  const [{ status, isPending }, doApi] = useMutation((api) => apiMutation(api));
  const [mergedOptions, setMergedOptions] = useState(null);
  const [graphSeriesData, setGraphSeriesData] = useState([]);
  const [graphSeries, setGraphSeries] = useState({});
  const [graphLabel, setGraphLabel] = useState([]);

  const cancelAllRequests = () => {
    controller.abort();
  };

  useEffect(() => {
    let isMounted = true;

    if (queries) {
      queries.forEach((query, i) => {
        if (query.tableId) {
          setTableId(query.tableId);
        }
        doApi(query).then((result) => {
          if (result.body.response) {
            let response = result.body.response;
            if (isMounted) {
              if (i === 0) {
                let label = [];

                if (response.dimension[query.dimension]) {
                  for (let i in response.dimension[query.dimension].category.label)
                    label.push(response.dimension[query.dimension].category.label[i]);
                  setGraphLabel(label);
                }
              }
              let seriesData = groupData(response, query.dimension, false);

              setGraphSeries({
                data: seriesData,
                type: query.graphType,
                name: query.name,
              });
            }
          }
        });
      });
    }

    return () => {
      isMounted = false;
      cancelAllRequests();
    };
  }, [queries]);

  useEffect(() => {
    if (graphSeries.data) {
      let data = Object.assign([], graphSeriesData);
      data.push(graphSeries);
      setGraphSeriesData(data.sort((a, b) => (a.name === "Elbiler" ? 1 : -1)));
    }
  }, [graphSeries]);

  useEffect(() => {
    if (graphLabel && graphSeriesData && graphSeriesData.length === queries.length) {
      let legend = graphSeriesData.map((obj) => {
        return obj.name;
      });
      let nObj = {
        ...JSON.parse(options),
        legend: {
          data: legend,
          left: "right",
        },
        xAxis: {
          type: "category",
          data: graphLabel,
          axisTick: 10,
        },
        series: [...graphSeriesData],
      };
      setMergedOptions(nObj);
    }
  }, [graphSeriesData]);

  if (isPending)
    return (
      <div className="spinner">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  if (status !== 200) return <p>Problems loading from external api</p>;

  if (mergedOptions) {
    return <ReactECharts option={mergedOptions} style={{ marginTop: "40px" }} />;
  }

  return null;
};
export default GraphMultiSeries;

const options = JSON.stringify({
  grid: { top: 8, right: 8, bottom: 24, left: 30, containLabel: true },
  // xAxis: {
  //   type: 'category',
  //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  // },
  yAxis: {
    type: "value",
  },
  // series: [
  //   {
  //     data: [820, 932, 901, 934, 1290, 1330, 1320],
  //     type: 'line',
  //     smooth: true,
  //   },
  // ],
  tooltip: {
    trigger: "axis",
  },
});
